module.exports = __webpack_public_path__ + "static/mural-1-7e94e6e587c08f4e0920bf322a798bc6.jpg";